export function useProductDelete({ mediaProductsPath, selectedProducts, setFieldValue }) {
  return deleteProductId => {
    // delete product
    setFieldValue(
      mediaProductsPath,
      selectedProducts.filter(productValues => productValues.data.id !== deleteProductId)
    )
  }
}
